import { Link, Typography } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';
const PrivacyPolicy = () => /*#__PURE__*/React.createElement(Typography, {
  variant: "body1"
}, /*#__PURE__*/React.createElement(Trans, {
  components: {
    privacyPolicy: /*#__PURE__*/React.createElement(Link, {
      href: "https://save.livable.com/privacypolicy",
      target: "_blank"
    })
  },
  i18nKey: "general.terms_and_conditions_body"
}));
export default PrivacyPolicy;